export const categories = [
  { id: "tortas-especiales", name: "Tortas Especiales", description: "Creaciones unicas para momentos especiales", icon: "sparkles" },
  { id: "refrigeradas", name: "Refrigeradas", description: "Frescura y sabor en cada bocado", icon: "snowflake" },
  { id: "refrigeradas-premium", name: "Refrigeradas Premium", description: "Línea exclusiva de tortas refrigeradas premium", icon: "snowflake" },
  { id: "clasicas", name: "Clasicas", description: "Los sabores de siempre que nunca fallan", icon: "heart" },
  { id: "saludables", name: "Saludables", description: "Sin azucar, sin gluten, sin culpa", icon: "leaf" },
  { id: "pide-para-hoy", name: "Pide para Hoy", description: "Disponibles para entrega inmediata", icon: "clock" },
  { id: "pinateria", name: "Piñatería", description: "Velas, globos, letreros y todo para tu fiesta", icon: "party-popper" },
  { id: "panaderia", name: "Panadería", description: "Pan fresco y horneado todos los días", icon: "cookie" },
  { id: "bebidas", name: "Bebidas", description: "Bebidas frías y calientes", icon: "cup" },
  { id: "cafeteria", name: "Cafetería", description: "Acompañamientos y repostería de café", icon: "coffee" }
];

export const products = [
  {
    id: "torta-red-velvet-premium",
    name: "Torta Red Velvet Premium",
    description: "Suave bizcocho red velvet con frosting de queso crema, decorada con petalos de rosa",
    category: "tortas-especiales",
    base_price: 120000,
    image: "https://images.unsplash.com/photo-1542826438-bd32f43d626f?w=600",
    sizes: [
      { name: "12 a 15 porciones", price: 120000, prep_days: 2 },
      { name: "20 a 25 porciones", price: 170000, prep_days: 3 },
      { name: "30 a 35 porciones", price: 220000, prep_days: 4 },
    ],
    fillings: [
      { name: "Queso Crema", price: 0 },
      { name: "Frutos Rojos", price: 15000 },
      { name: "Arequipe", price: 10000 },
    ],
    flavors: [
      { name: "Red Velvet Clasico", price: 0 },
      { name: "Red Velvet Chocolate", price: 8000 },
    ],
    complements: [
      { name: "Velas (x12)", price: 5000 },
      { name: "Letrero personalizado", price: 12000 },
      { name: "Topper acrilico", price: 25000 },
    ],
    available: true,
    preparation_days: 2,
    is_featured: true,
    is_popular: true,
  },
  {
    id: "torta-chocolate-belga",
    name: "Torta de Chocolate Belga",
    description: "Triple chocolate con ganache de chocolate belga al 70%, decorada con virutas de oro",
    category: "tortas-especiales",
    base_price: 140000,
    image: "https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=600",
    sizes: [
      { name: "12 a 15 porciones", price: 140000, prep_days: 2 },
      { name: "20 a 25 porciones", price: 200000, prep_days: 3 },
      { name: "30 a 35 porciones", price: 260000, prep_days: 4 },
    ],
    fillings: [
      { name: "Ganache Chocolate", price: 0 },
      { name: "Mousse de Chocolate", price: 20000 },
      { name: "Dulce de Leche", price: 15000 },
    ],
    flavors: [
      { name: "Chocolate Negro 70%", price: 0 },
      { name: "Chocolate con Cafe", price: 10000 },
    ],
    complements: [
      { name: "Velas (x12)", price: 5000 },
      { name: "Letrero personalizado", price: 12000 },
      { name: "Macarons (x6)", price: 18000 },
    ],
    available: true,
    preparation_days: 2,
    is_featured: true,
    is_popular: true,
  },
  {
    id: "torta-floral-vainilla",
    name: "Torta Floral de Vainilla",
    description: "Elegante torta de vainilla con decoracion floral artesanal en buttercream",
    category: "tortas-especiales",
    base_price: 150000,
    image: "https://images.unsplash.com/photo-1659271940584-25589f320198?w=600",
    sizes: [
      { name: "12 a 15 porciones", price: 150000, prep_days: 3 },
      { name: "20 a 25 porciones", price: 215000, prep_days: 4 },
      { name: "30 a 35 porciones", price: 280000, prep_days: 5 },
    ],
    fillings: [
      { name: "Buttercream Vainilla", price: 0 },
      { name: "Crema de Limon", price: 12000 },
    ],
    flavors: [{ name: "Vainilla Premium", price: 0 }],
    complements: [
      { name: "Velas (x12)", price: 5000 },
      { name: "Topper acrilico", price: 25000 },
    ],
    available: true,
    preparation_days: 3,
    is_featured: true,
    is_popular: false,
  },
  {
    id: "cheesecake-maracuya",
    name: "Cheesecake de Maracuya",
    description: "Cremoso cheesecake con coulis de maracuya y base de galleta graham",
    category: "refrigeradas",
    base_price: 95000,
    image: "https://images.unsplash.com/photo-1533134242443-d4fd215305ad?w=600",
    sizes: [
      { name: "6 a 8 porciones", price: 95000, prep_days: 1 },
      { name: "12 a 15 porciones", price: 140000, prep_days: 2 },
    ],
    fillings: [
      { name: "Maracuya Natural", price: 0 },
      { name: "Frutos Rojos", price: 12000 },
    ],
    flavors: [{ name: "Cheesecake Clasico", price: 0 }],
    complements: [
      { name: "Velas (x12)", price: 5000 },
      { name: "Frutas frescas extra", price: 15000 },
    ],
    available: true,
    preparation_days: 1,
    is_featured: false,
    is_popular: true,
  },
  {
    id: "tiramisu-italiano",
    name: "Tiramisu Italiano",
    description: "Autentico tiramisu con mascarpone importado, cafe espresso y cacao amargo",
    category: "refrigeradas",
    base_price: 85000,
    image: "https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=600",
    sizes: [
      { name: "6 a 8 porciones", price: 85000, prep_days: 1 },
      { name: "12 a 15 porciones", price: 125000, prep_days: 2 },
    ],
    fillings: [{ name: "Mascarpone Clasico", price: 0 }],
    flavors: [
      { name: "Cafe Tradicional", price: 0 },
      { name: "Chocolate", price: 8000 },
    ],
    complements: [{ name: "Cacao extra", price: 5000 }],
    available: true,
    preparation_days: 1,
    is_featured: false,
    is_popular: false,
  },
  {
    id: "torta-vainilla-clasica",
    name: "Torta de Vainilla Clasica",
    description: "Esponjosa torta de vainilla con buttercream y decoracion artesanal",
    category: "clasicas",
    base_price: 75000,
    image: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600",
    sizes: [
      { name: "Personal (6 porciones)", price: 75000, prep_days: 1 },
      { name: "Mediana (12 porciones)", price: 110000, prep_days: 2 },
      { name: "Grande (20 porciones)", price: 145000, prep_days: 3 },
    ],
    fillings: [
      { name: "Buttercream Vainilla", price: 0 },
      { name: "Arequipe", price: 10000 },
      { name: "Mermelada de Fresa", price: 8000 },
    ],
    flavors: [
      { name: "Vainilla Natural", price: 0 },
      { name: "Vainilla con Chips", price: 5000 },
    ],
    complements: [
      { name: "Velas (x12)", price: 5000 },
      { name: "Letrero personalizado", price: 12000 },
      { name: "Globos (x5)", price: 15000 },
    ],
    available: true,
    preparation_days: 1,
    is_featured: false,
    is_popular: true,
  },
  {
    id: "torta-tres-leches",
    name: "Torta Tres Leches",
    description: "La receta tradicional colombiana banada en tres leches y merengue suizo",
    category: "clasicas",
    base_price: 70000,
    image: "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=600",
    sizes: [
      { name: "Personal (6 porciones)", price: 70000, prep_days: 1 },
      { name: "Mediana (12 porciones)", price: 100000, prep_days: 2 },
    ],
    fillings: [{ name: "Tres Leches Original", price: 0 }],
    flavors: [
      { name: "Clasica", price: 0 },
      { name: "Con Fresas", price: 10000 },
    ],
    complements: [{ name: "Velas (x12)", price: 5000 }],
    available: true,
    preparation_days: 1,
    is_featured: true,
    is_popular: false,
  },
  {
    id: "torta-keto-almendras",
    name: "Torta Keto de Almendras",
    description: "Sin azucar, sin gluten. Harina de almendras con eritritol y crema de coco",
    category: "saludables",
    base_price: 110000,
    image: "https://images.unsplash.com/photo-1606890737304-57a1ca8a5b62?w=600",
    sizes: [
      { name: "Personal (6 porciones)", price: 110000, prep_days: 2 },
      { name: "Mediana (12 porciones)", price: 165000, prep_days: 3 },
    ],
    fillings: [
      { name: "Crema de Coco", price: 0 },
      { name: "Mantequilla de Mani", price: 12000 },
    ],
    flavors: [{ name: "Almendras Natural", price: 0 }],
    complements: [{ name: "Frutas frescas", price: 15000 }],
    available: true,
    preparation_days: 2,
    is_featured: false,
    is_popular: false,
  },
  {
    id: "cupcakes-surtidos",
    name: "Cupcakes Surtidos (x12)",
    description: "Docena de cupcakes con diferentes sabores y decoraciones del dia",
    category: "pide-para-hoy",
    base_price: 48000,
    image: "https://images.unsplash.com/photo-1587668178277-295251f900ce?w=600",
    sizes: [
      { name: "Docena (12 unidades)", price: 48000, prep_days: 0 },
      { name: "Media docena (6)", price: 28000, prep_days: 0 },
    ],
    fillings: [],
    flavors: [{ name: "Surtido del dia", price: 0 }],
    complements: [{ name: "Caja regalo", price: 8000 }],
    available: true,
    preparation_days: 0,
    is_featured: false,
    is_popular: true,
  },
  {
    id: "brownies-artesanales",
    name: "Brownies Artesanales (x8)",
    description: "Brownies humedos de chocolate con nueces, listos para llevar",
    category: "pide-para-hoy",
    base_price: 35000,
    image: "https://images.unsplash.com/photo-1515037893149-de7f840978e2?w=600",
    sizes: [{ name: "Caja (8 unidades)", price: 35000, prep_days: 0 }],
    fillings: [],
    flavors: [
      { name: "Chocolate con Nueces", price: 0 },
      { name: "Doble Chocolate", price: 5000 },
    ],
    complements: [{ name: "Caja regalo", price: 8000 }],
    available: true,
    preparation_days: 0,
    is_featured: false,
    is_popular: false,
  },
];

export const featuredProducts = products.filter(p => p.is_featured);
export const popularProducts = products.filter(p => p.is_popular);

export const getProductById = (id) => products.find(p => p.id === id);

export const getProductsByCategory = (category) =>
  category ? products.filter(p => p.category === category) : products;

export const searchProducts = (query) => {
  if (!query) return products;
  const q = query.toLowerCase();
  return products.filter(p =>
    p.name.toLowerCase().includes(q) || p.description.toLowerCase().includes(q)
  );
};

export const categoryNames = {
  'tortas-especiales': 'Tortas Especiales',
  'tortas-personalizadas': 'Tortas Personalizadas',
  'tortas-tematicas': 'Tortas Temáticas',
  'mesa-dulces': 'Mesa de Dulces',
  'detalles-regalos': 'Detalles y Regalos',
  'tortas': 'Tortas',
  'refrigeradas': 'Refrigeradas',
  'refrigeradas-premium': 'Refrigeradas Premium',
  'clasicas': 'Clasicas',
  'saludables': 'Saludables',
  'grados': 'Grados',
  'comunion': 'Primera Comunión',
  'pide-para-hoy': 'Pide para Hoy',
  'pinateria': 'Piñatería',
  'panaderia': 'Panadería',
  'bebidas': 'Bebidas',
  'cafeteria': 'Cafetería',
};
